import React from "react";
import styled from "styled-components";

const Button = ({ type, onClick, label, ...rest }) => {
  return (
    <ButtonStyled type={type} onClick={onClick} {...rest}>
      {label}
    </ButtonStyled>
  );
};

export default Button;

const ButtonStyled = styled.button`
  min-width: 12rem;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  padding: 1rem 2rem;
  line-height: 0rem;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.fonts.sequel65};
  color: ${(props) =>
    props.primary
      ? props.theme.colors.primary
      : props.secondary
      ? props.theme.colors.white
      : props.theme.colors.white};
  border: 1px solid
    ${(props) =>
      props.primary
        ? props.theme.colors.primary
        : props.secondary
        ? props.theme.colors.secondary
        : props.theme.colors.white};
  background-color: ${(props) =>
    props.primary
      ? `transparent`
      : props.secondary
      ? props.theme.colors.secondary
      : `transparent`};
  font-size: 1.6rem;
  height: 5.5rem;
  &:hover {
    transition-duration: 0.4s;
    background-color: ${(props) =>
      props.primary
        ? props.theme.colors.primary
        : props.secondary
        ? "#266981"
        : props.theme.colors.white};
    border: 1px solid
      ${(props) =>
        props.primary
          ? props.theme.colors.primary
          : props.secondary
          ? props.theme.colors.secondary
          : props.theme.colors.white};
    color: ${(props) =>
      props.primary
        ? props.theme.colors.white
        : props.secondary
        ? props.theme.colors.white
        : props.theme.colors.primary};
  }
  @media ${({ theme }) => theme.breakpoints.mobile} {
    width: 100%;
  }
`;
